import UnfilledButton from "@/components/common/unfilled-button";

type CancelButtonProps = {
  onCancel: () => void;
  isCancelling: boolean;
};

const CancelButton = ({ onCancel, isCancelling }: CancelButtonProps) => {
  return (
    <UnfilledButton
      text={"Cancel"}
      onClick={onCancel}
      disabled={isCancelling}
    />
  );
};

export default CancelButton;
